import React, { memo, useCallback, useRef, useState } from "react";

import { RowData, TableOptionsProps } from "./types";
import { ReactComponent as OptionsIcon } from "./assets/options.svg";

import { OptionsDropdown } from "./OptionsDropdown";
import { OptionsButtonStyled } from "./styles";

type TableOptionsComponent = <T extends RowData>(
  props: TableOptionsProps<T>
) => JSX.Element | null;
export const TableOptions: TableOptionsComponent = memo(
  ({ item, options, optionsDropdownOffset }) => {
    const optionsButtonRef = useRef(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const toggleDropdown = useCallback(() => {
      setIsDropdownOpen(!isDropdownOpen);
    }, [isDropdownOpen]);

    const handleButtonClick = useCallback(
      (e: React.MouseEvent) => {
        e.stopPropagation();
        toggleDropdown();
      },
      [toggleDropdown]
    );

    return Array.isArray(options) ? (
      <>
        <OptionsButtonStyled
          data-test-id="open-mission-options-button"
          onClick={handleButtonClick}
          ref={optionsButtonRef}
          isHidden={options.every((option) => option?.isHide?.(item))}
        >
          <OptionsIcon />
        </OptionsButtonStyled>
        {isDropdownOpen && (
          <OptionsDropdown
            toggleDropdown={toggleDropdown}
            optionsButtonRef={optionsButtonRef}
            optionsDropdownOffset={optionsDropdownOffset}
            item={item}
            options={options}
          />
        )}
      </>
    ) : (
      <OptionsButtonStyled
        onClick={(e) => {
          e.stopPropagation();
          options.callback(item);
        }}
        isHidden={false}
      >
        {options.icon}
      </OptionsButtonStyled>
    );
  }
);
